import { Table, TableBody, TableCell, TableContainer, TableRow } from "@mui/material";
import { useTranslation } from "react-i18next";

const FormSubList = ({equipmentNoList}) => {
    const { t } = useTranslation();

    if (equipmentNoList) {
        return (
        <div>
            <TableContainer style={{width:"400px"}}>
                <Table sx={{ minWidth: 400 }} aria-label="simple table" style={{borderTop:"2px solid #a2a2a2"}}>
                <TableBody style={{height:"auto"}}>
                    <TableRow>
                        <TableCell className="th">{t('message.common.subtitle.equipment.name')}</TableCell>
                        <TableCell className="th">{t('message.common.subtitle.equipment.number')}</TableCell>
                    </TableRow>
                    {equipmentNoList.map(function(item, i) {
                        return (
                    <TableRow key={i}>
                        <TableCell>{item.name}</TableCell>
                        <TableCell>{item.equipmentNo}</TableCell>
                    </TableRow>
                        )
                    })}
                </TableBody>
                </Table>
            </TableContainer>
        </div>
        )
    }
}

export default FormSubList;